import _ from 'lodash';
import domains from '../containers/Domains';
import contextMakePost from './Context';
import {getLocalStorageDataOrFetch} from './fbCallManager';

const endpoint = domains.fbEndpoint;

export const createCanvasButton = async (data, token) => {
  const parameters = {
    access_token: token,
    canvas_button: data.canvas_button,
  };

  const id = data.id;
  const result = await contextMakePost(parameters, id);
  return result.json();
};

export const getCanvasButton = async (id, token) => {
  const parameters = {
    access_token: token,
    id,
    fields: 'id,name,action'
  };

  const query = _.template(`${endpoint}<%= id%>?&fields=<%= fields%>&access_token=<%= access_token%>`);
  
  const jsonResult = await getLocalStorageDataOrFetch(query(parameters))
  
  return jsonResult;
};


// WEBPACK FOOTER //
// ./src/fbApi/Button.js